// extracted by mini-css-extract-plugin
export var coming = "style-module--coming--1d38f";
export var headline = "style-module--headline--c1f5c";
export var listBox = "style-module--listBox--7a57d";
export var subLine = "style-module--subLine--080ca";